import TestController from '@/controllers/TestController';
import Test from '@/models/Test';
import INavigationController from '../INavigationController';
import AbstractNavigationState from './AbstractNavigationState';
import ItemNavigationState from './ItemNavigationState';
import NavigationCallbackType from './NavigationCallbackType';
import SectionEndNavigationState from './SectionEndNavigationState';
import TestEndNavigationState from './TestEndNavigationState';

class NavigationContext {
  public static readonly ITEM_STATE: string = 'item';
  public static readonly SECTION_END_STATE: string = 'sectionEnd';
  public static readonly TEST_END_STATE: string = 'testEnd';

  private navigationStateMap: Map<string, AbstractNavigationState> = new Map();
  private _navigationState: AbstractNavigationState | undefined;
  private readonly testController: TestController;
  constructor(navigationController: INavigationController, lockSectionsEnabled: boolean, showReviewScreen: boolean) {
    this.testController = navigationController.testController;

    this.navigationStateMap.set(
      NavigationContext.ITEM_STATE,
      new ItemNavigationState(navigationController, this, lockSectionsEnabled, showReviewScreen)
    );
    this.navigationStateMap.set(
      NavigationContext.SECTION_END_STATE,
      new SectionEndNavigationState(navigationController, this, lockSectionsEnabled)
    );
    this.navigationStateMap.set(
      NavigationContext.TEST_END_STATE,
      new TestEndNavigationState(navigationController, this, lockSectionsEnabled)
    );

    this._navigationState = this.navigationStateMap.get(NavigationContext.ITEM_STATE);
  }

  setNavigationState(navigationStateKey: string | null) {
    if (navigationStateKey) {
      this._navigationState = this.navigationStateMap.get(navigationStateKey);
      if (this._navigationState && this.testController.test) {
        if (this.testController.test.locationState !== Test.SECTION_INSTRUCTIONS_STATE) {
          this.testController.test.locationState = this._navigationState.getLocationState();
        }
        this.testController.sessionController?.itemStateChangedEvent();
      }
    }
  }

  isReviewScreen(): boolean {
    return this._navigationState !== undefined && !(this._navigationState instanceof ItemNavigationState);
  }

  setNavigationStateFromLocationState(navigationCallback: (NavigationCallbackType) => void): void {
    switch (this.testController.test!.locationState) {
      case Test.SECTION_END_STATE: {
        this.setNavigationState(NavigationContext.SECTION_END_STATE);
        break;
      }
      case Test.TEST_END_STATE: {
        this.setNavigationState(NavigationContext.TEST_END_STATE);
        break;
      }
      default: {
        this.setNavigationState(NavigationContext.ITEM_STATE);
        break;
      }
    }
    navigationCallback(NavigationCallbackType.CURRENT);
  }

  get navigationState(): AbstractNavigationState | undefined {
    return this._navigationState;
  }

  navigationStateIsReviewScreen(): boolean {
    return this.navigationState !== undefined && !(this.navigationState instanceof ItemNavigationState);
  }
}

export default NavigationContext;
